var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { Icon } from '@iconify/react';
/**
 * Enter channel to express yourself, such as personal blog, YouTube, etc.
 *
 * @props redirectUrl: URL you want to redirect when clicked (default: '/')
 * @props name: Channel name (default: 'github')
 * @props color: Channel icon color style (default: 'black')
 * @props size: Channel icon size style (default: '24px')
 * @props margin: Channel margin style (default: '0px 6px')
 * @props padding: Channel padding style (default: '0px')
 */
var Channel = function (_a) {
    var redirectUrl = _a.redirectUrl, name = _a.name, color = _a.color, size = _a.size, margin = _a.margin, padding = _a.padding;
    return (_jsx(Container, __assign({ margin: margin, padding: padding }, { children: _jsx(Link, __assign({ href: redirectUrl }, { children: _jsx(Icon, { icon: "simple-icons:".concat(name), color: color, fontSize: size }) })) })));
};
export default Channel;
Channel.defaultProps = {
    redirectUrl: '/',
    name: 'github',
    color: 'black',
    size: '24px',
    margin: '0px 6px',
    padding: '0px',
};
var Container = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: ", ";\n  padding: ", ";\n"], ["\n  margin: ", ";\n  padding: ", ";\n"])), function (_a) {
    var margin = _a.margin;
    return margin;
}, function (_a) {
    var padding = _a.padding;
    return padding;
});
var Link = styled.a(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  &:hover {\n    scale: calc(1.05);\n  }\n"], ["\n  &:hover {\n    scale: calc(1.05);\n  }\n"])));
var templateObject_1, templateObject_2;
